export const validationList = {
  validDecimal: new RegExp(/-?(0|[1-9][0-9]*)(\.[0-9]+)?([eE][+-]?[0-9]+)?/),
}

export const numberRangeMinValue = -2147483648
export const numberRangeMaxValue = 2147483647
